import React, { useEffect } from "react";

import ComplianceTable from "components/tables/ComplianceTable";
import { Card, Col, Row, Table } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";

import "bootstrap/dist/css/bootstrap.min.css";

const LegendTable = () => (
  <Table bordered size="sm">
    <thead>
      <tr>
        <th className="text-center">Colour legend</th>
        <th className="text-center">StationStatus.state</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="text-center">
          <BsFillCircleFill color="green" />
        </td>
        <td className="text-center">COMPLIANT</td>
      </tr>
      <tr>
        <td className="text-center">
          <BsFillCircleFill color="yellow" />
        </td>
        <td className="text-center">REQUIRES ATTENTION</td>
      </tr>
      <tr>
        <td className="text-center">
          <BsFillCircleFill color="red" />
        </td>
        <td className="text-center">NONCOMPLIANT</td>
      </tr>
    </tbody>
  </Table>
);

const GeneralDescriptionCard = ({
  innerRef,
  stationName,
  data,
  stationCity,
  stationCoords,
  startDate,
  stopDate,
}) => {
  

  return(
  <Row className="m-3" ref={innerRef}>
    <Col md={{ span: 12, offset: 0 }}>
      <Card>
        <Card.Body>
          <Row className="mt-5 mb-5">
            <Col md={{ span: 8, offset: 2 }}>
              <h4 className="text-center">
                GNSS Signal-in-Space Performance and Interference Statistics
                Report <br></br>
                {stationName} <br></br>
                {startDate.replace(/-/g, "/")} - {stopDate.replace(/-/g, "/")}
              </h4>
            </Col>
          </Row>
          <p>
            This report presents the GNSS Signal-in-Space performance and
            information about interference events for a period of 14 days. The
            data was collected from the GNSS and interference monitoring station
            at {stationCity} ({stationCoords}).
          </p>
          <p>
            The following table presents a summary of the monitored KPIs with
            respect to their compliance to the recommended thresholds.
          </p>
          <Col md={{ span: 4, offset: 4 }}>
            <LegendTable />
          </Col>
          <ComplianceTable data={data.complianceTable} />
        </Card.Body>
      </Card>
    </Col>
  </Row>
)};

// export default React.forwardRef((props, ref) => (
//   <GeneralDescriptionCard innerRef={ref} {...props} />
// ));

export default React.memo(
  React.forwardRef((props, ref) => <GeneralDescriptionCard innerRef={ref} {...props} />)
);
